import { useState } from "react";
import { useNavigate } from "react-router-dom";
import './Login.css'
export default function Login() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();

    const submit = async e => {
        e.preventDefault();

        const res = await fetch("https://planning.amservices.eu/api/auth/login.php", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ username, password })
        });

        const data = await res.json();

        if (!res.ok) {
            setError(data.error || "Erreur");
            return;
        }

        localStorage.setItem("token", data.token);
        navigate("/planning");
    };

    return (
        <div className="login-container">
            <div className="login-card">
                <h1>Connexion</h1>

                <form className="login-form" onSubmit={submit}>
                    {error && <div className="login-error">{error}</div>}

                    <input
                        type="text"
                        placeholder="Nom d'utilisateur"
                        value={username}
                        onChange={e => setUsername(e.target.value)}
                    />

                    <input
                        type="password"
                        placeholder="Mot de passe"
                        value={password}
                        onChange={e => setPassword(e.target.value)}
                    />

                    <button type="submit">Se connecter</button>
                </form>
            </div>
        </div>

    );
}
